import type { FC, PropsWithChildren } from 'react'

import type { TrLinkProps } from '@skytech/ui/Table/TrLink'
import { TrLink as UITrLink } from '@skytech/ui/Table/TrLink'
import { useNavigate } from 'react-router-dom'

export const TrLink: FC<PropsWithChildren<Omit<TrLinkProps, 'onNavigate'>>> = props => {
  const navigate = useNavigate()

  return <UITrLink onNavigate={navigate} {...props} />
}
